import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { Navbar } from '@/components/Navbar';
import { fetchAdminMe, isStaffRole } from '@/lib/adminApi';

export function AdminProtectedRoute({ children }) {
  const token = localStorage.getItem('storycraft_token');
  const [state, setState] = useState({ loading: true, allowed: false });

  useEffect(() => {
    if (!token) {
      setState({ loading: false, allowed: false });
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const me = await fetchAdminMe();
        if (!cancelled) {
          setState({ loading: false, allowed: isStaffRole(me.role) });
          localStorage.setItem(
            'storycraft_user',
            JSON.stringify({
              ...(JSON.parse(localStorage.getItem('storycraft_user') || '{}')),
              role: me.role,
              permissions: me.permissions,
            }),
          );
        }
      } catch {
        if (!cancelled) setState({ loading: false, allowed: false });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  if (!token) return <Navigate to="/login" replace />;
  if (state.loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-indigo-500" />
      </div>
    );
  }
  if (!state.allowed) return <Navigate to="/dashboard" replace />;

  return children;
}
